export const UNIFIED_FILE_SEARCH_FLAG = 'AHA-48595-unified-file-search'

// Gate on the variant name, never on enabled/disabled: a missing flag reports `disabled`,
// which a boolean check would conflate with control.
export const UNIFIED_FILE_SEARCH_VARIANTS = {
  TREATMENT: 'treatment',
  CONTROL: 'control',
}

export const WORKSPACE_SEARCH_PATH = 'search'
